import { Flex, Tooltip } from 'antd';
import ActionWidget, { ActionWidgetSkeleton } from './ActionWidget';
import { renderInfoValue } from 'utils/helpers';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface StuckPackagesWidgetProps {
  data?: unknown;

  onCtaClick?: () => void;
  isLoading?: boolean;
  title: React.ReactNode;
}

const StuckPackagesWidget = ({
  title,
  data,
  isLoading,
  onCtaClick,
}: StuckPackagesWidgetProps) => {
  if (isLoading) return <ActionWidgetSkeleton />;
  const { t } = useTranslation();

  return (
    <ActionWidget
      title={title}
      data={
        <Flex align="center" gap={10}>
          {renderInfoValue((data || 0) as string, 'N/A')}
          <Tooltip
            title={t('packageTrackerDashboard.tooltips.stuckPackageInfo')}
            className="clickable"
          >
            <ExclamationCircleOutlined
              style={{ color: '#256AF4', fontSize: '18px' }}
            />
          </Tooltip>
        </Flex>
      }
      ctaContent="View Packages"
      onCtaClick={onCtaClick}
    />
  );
};

export default StuckPackagesWidget;
